import React, { useEffect, useState } from "react"
import { get, post } from "../../utils/apiClient"
import { displayNetIdEmail } from "../../utils/common"
import toast from "react-hot-toast"
import Select from "react-select"

export default function NetIdSharingPermissionModal({
  onClose,
  onSaved,
  editData,
  authUser,
}) {
  const [sharedBy, setSharedBy] = useState([])
  const [sharedWith, setSharedWith] = useState([])

  // const [sharedByOrg, setSharedByOrg] = useState([])
  // const [sharedWithOrg, setSharedWithOrg] = useState([])

  const [templates, setTemplates] = useState({})

  // const [defaultRoleWisePermissions, setDefaultRoleWisePermissions] = useState(
  //   []
  // )

  const [selectedSharedBy, setSelectedSharedBy] = useState("")
  const [selectedSharedWith, setSelectedSharedWith] = useState("")

  const [rolePermissions, setRolePermissions] = useState({})
  const [initialPermissions, setInitialPermissions] = useState({}) // used for reload default

  const [loading, setLoading] = useState(false)
  const [actionLoading, setActionLoading] = useState(false)

  const [errorMessage, setErrorMessage] = useState("")

  useEffect(() => {
    const loadDetails = async () => {
      setLoading(true)
      try {
        const param =
          authUser.loggedInUserType === "USER"
            ? `?sharedBy=${authUser.netId}`
            : ""
        const data = await get(`/manage/shared/by${param}`)
        setSharedBy(data.sharedByNetIds || [])
        setSharedWith(data.sharedWithNetIds || [])

        // setSharedByOrg(data.sharedByNetIds || [])
        // setSharedWithOrg(data.sharedWithNetIds || [])

        setTemplates(data.globalPermissionTemplate || {})
        //setDefaultRoleWisePermissions([])

        if (editData) {
          // Edit mode — fill from existing record
          setSelectedSharedBy({ netId: editData.sharedBy })
          setSelectedSharedWith({ netId: editData.sharedWith })
          setRolePermissions(editData.permissions || {})
          setInitialPermissions(editData.permissions || {})
        } else {
          // Add mode — fill defaults from role
          const defaultNet = data.sharedByNetIds[0] || ""
          const defaultQueue = data.sharedWithNetIds[0] || ""

          setSelectedSharedBy(defaultNet)
          setSelectedSharedWith(defaultQueue)

          // const defaultPerm =
          //   (
          //     data.defaultRoleWisePermissions.find(
          //       (r) => r.role === defaultRole
          //     ) || {}
          //   ).permissions || {}
          // setRolePermissions(defaultPerm)
          // setInitialPermissions({})
        }
      } catch {
        toast.error("Failed to load permission details")
      }
      setLoading(false)
    }

    loadDetails()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editData])

  // useEffect(() => {
  //   if (selectedSharedBy !== "") {
  //     const sb = sharedByOrg.filter((s) => s !== selectedSharedBy)
  //     setSharedBy(sb)
  //     if (selectedSharedWith !== sb[0]) setSelectedSharedWith(sb[0])
  //   }
  //   if (selectedSharedWith !== "") {
  //     const sw = sharedWithOrg.filter((s) => s !== selectedSharedWith)
  //     setSharedWith(sw)
  //     if (selectedSharedBy !== sw[0]) setSelectedSharedBy(sw[0])
  //   }
  // }, [selectedSharedBy, selectedSharedWith, sharedByOrg, sharedWithOrg])

  const handlePermissionToggle = (category, permKey) => {
    setRolePermissions((prev) => {
      const categoryPerms = new Set(prev[category] || [])
      categoryPerms.has(permKey)
        ? categoryPerms.delete(permKey)
        : categoryPerms.add(permKey)
      return { ...prev, [category]: Array.from(categoryPerms) }
    })
  }

  const handleReset = () => {
    setRolePermissions(initialPermissions)
  }

  const handleSave = async () => {
    setActionLoading(true)
    try {
      const sharedByFaxNumber = sharedBy.find(
        (by) => by.netId === selectedSharedBy.netId,
      )?.faxNumber

      if (sharedByFaxNumber === null) {
        setErrorMessage(
          "Unable to save permissions. The selected 'Shared By' NetID must be associated with a fax number before it can be shared.",
        )
        setActionLoading(false)
        return
      }

      if (selectedSharedBy.netId === selectedSharedWith.netId) {
        setErrorMessage("SharedBy and SharedWith can not be same.")
        setActionLoading(false)
        return
      }

      let params = {
        sharedBy: selectedSharedBy.netId,
        sharedWith: selectedSharedWith.netId,
        sharedByEmailAddress:
          sharedBy.find((v) => v.netId === selectedSharedBy.netId)
            ?.emailAddress || "",
        sharedWithEmailAddress:
          sharedWith.find((v) => v.netId === selectedSharedWith.netId)
            ?.emailAddress || "",
        permissions: rolePermissions,
      }

      if (editData) {
        params = {
          sharedAccessId: editData.sharedAccessId,
          ...params,
        }
      }

      await post("/manage/share/netId/with-permissions", params)
      if (editData) {
        toast.success("NetId sharing updated successfully")
      } else {
        toast.success("NetId sharing created successfully")
      }
      onSaved()
      setActionLoading(false)
      setErrorMessage("")
    } catch (error) {
      toast.error(error, {
        duration: 5000,
      })
      setActionLoading(false)
    }
  }

  // const optionSharedBy = sharedBy
  //   .map((n) => ({ value: n, label: n }))
  //   .sort((a, b) => a.value.localeCompare(b.value))

  // const optionSharedWith = sharedWith
  //   .map((n) => ({ value: n, label: n }))
  //   .sort((a, b) => a.value.localeCompare(b.value))

  const optionSharedBy = [
    ...new Map(
      sharedBy.map((r) => [
        r.netId,
        displayNetIdEmail(r.netId, r.emailAddress),
      ]),
    ).entries(),
  ]
    .map(([netId, label]) => ({
      value: netId,
      label: label,
    }))
    .sort((a, b) => a.label.localeCompare(b.label))

  const optionSharedWith = [
    ...new Map(
      sharedWith.map((r) => [
        r.netId,
        displayNetIdEmail(r.netId, r.emailAddress),
      ]),
    ).entries(),
  ]
    .map(([netId, label]) => ({
      value: netId,
      label: label,
    }))
    .sort((a, b) => a.label.localeCompare(b.label))

  return (
    <div className="checkbox-popup-overlay">
      <div className="checkbox-popup-modal">
        <div className="checkbox-popup-header">
          <h3 className="popup-title">
            {editData
              ? "Edit NetId Sharing Permission"
              : "Share NetId with Permissions"}
          </h3>
          <button
            type="button"
            onClick={onClose}
            style={{
              background: "transparent",
              border: "none",
              fontSize: 24,
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>

        {loading ? (
          <div className="loading-container-fax-list">
            <div className="loading-message">Loading...</div>
          </div>
        ) : (
          <>
            <div className="checkbox-popup-body">
              <div
                style={{
                  display: "flex",
                  gap: "20px", // space between each dropdown group
                  marginBottom: "10px",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <label htmlFor="selectNetId">Shared By:</label>
                  <Select
                    id="roleSelect"
                    className="basic-single"
                    classNamePrefix="select"
                    value={optionSharedBy.find(
                      (option) => option.value === selectedSharedBy?.netId,
                    )}
                    onChange={(selectedOption) => {
                      setSelectedSharedBy({
                        ...selectedOption,
                        netId: selectedOption?.value,
                      })
                      setErrorMessage("")
                    }}
                    options={optionSharedBy}
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderRadius: 0,
                        width: "300px",
                      }),
                    }}
                    isSearchable
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <label>Shared With:</label>

                  <Select
                    id="roleSelect"
                    className="basic-single"
                    classNamePrefix="select"
                    value={optionSharedWith.find(
                      (option) => option.value === selectedSharedWith?.netId,
                    )}
                    onChange={(selectedOption) => {
                      setSelectedSharedWith({
                        ...selectedOption,
                        netId: selectedOption?.value,
                      })
                      setErrorMessage("")
                    }}
                    options={optionSharedWith}
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderRadius: 0,
                        width: "300px",
                      }),
                    }}
                    isSearchable
                  />
                </div>
              </div>

              {/* Permissions */}
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  marginTop: "30px",
                  flexWrap: "wrap",
                }}
              >
                {Object.entries(templates).map(([category, perms]) => {
                  if (Object.keys(perms).length === 0) {
                    return <></>
                  }
                  return (
                    <div
                      className="permission-box"
                      key={category}
                      style={{ flex: "1 1 200px" }}
                    >
                      <h3>{category}</h3>
                      {Object.entries(perms).map(([permKey, permDesc]) => (
                        <div key={permKey}>
                          <label>
                            <input
                              type="checkbox"
                              checked={
                                rolePermissions[category]?.includes(permKey) ||
                                false
                              }
                              onChange={() =>
                                handlePermissionToggle(category, permKey)
                              }
                            />
                            {permDesc}
                          </label>
                        </div>
                      ))}
                    </div>
                  )
                })}
              </div>
            </div>

            {/* Action buttons */}
            <div className="checkbox-popup-footer popup-buttons">
              {" "}
              {errorMessage && (
                <div className="error-message" style={{ margin: "10px" }}>
                  {errorMessage}
                </div>
              )}
              {editData && (
                <button type="button" onClick={handleReset}>
                  Reload default
                </button>
              )}
              <button
                className="popup-button cancel"
                type="button"
                onClick={onClose}
                style={{ marginLeft: "10px" }}
              >
                Cancel
              </button>
              <button
                className="popup-button save"
                type="button"
                onClick={handleSave}
                style={{ marginLeft: "10px" }}
              >
                {!actionLoading ? `Save` : `Saving ...`}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
